import { create } from 'zustand'
import {IHouse, IRoomVariables} from "../interfaces";

interface IVStore {
    houseData: IHouse[];
    priceRange: {
        min: number;
        max: number;
    }
    sizeRange: {
        min: number;
        max: number;
    }
    screenshotMode: boolean;
    currentFilter: string;
    roomVariables: IRoomVariables;
    isLoading: boolean;

    setHouseData: (houseData: IHouse[]) => void;
    changePriceRange: (range: { min: number; max: number }) => void;
    changeSizeRange: (range: { min: number; max: number }) => void;
    setScreenshotMode: (screenshotMode: boolean) => void;
    setCurrentFilter: (currentFilter: string) => void;
    setCurrentRoomVariables: (currentRoomVariables: IRoomVariables) => void;
    setIsLoading: (isLoading: boolean) => void;
}

const VStore = create<IVStore>((set) => ({
    houseData: [
        {
            name: 'House 1',
            price: 100000,
            size: 4000,
            bedroom: 2,
            bathroom: 1,
            garage: 1,
            imgSrc: './assets/images/house-1.png'
        },
        {
            name: 'House 2',
            price: 200000,
            size: 3000,
            bedroom: 3,
            bathroom: 2,
            garage: 2,
            imgSrc: './assets/images/house-1.png'
        },
        {
            name: 'House 3',
            price: 300000,
            size: 3000,
            bedroom: 4,
            bathroom: 3,
            garage: 3,
            imgSrc: './assets/images/house-1.png'
        },
        {
            name: 'House 4',
            price: 200000,
            size: 500,
            bedroom: 3,
            bathroom: 2,
            garage: 2,
            imgSrc: './assets/images/house-1.png'
        },
        {
            name: 'House 5',
            price: 400000,
            size: 2000,
            bedroom: 4,
            bathroom: 3,
            garage: 3,
            imgSrc: './assets/images/house-1.png'
        },
    ],
    priceRange: {
        min: 0,
        max: 0,
    },
    sizeRange: {
        min: 0,
        max: 0,
    },
    screenshotMode: false,
    currentFilter: '',
    roomVariables: {
        bedroom: 0,
        bathroom: 2,
        garage: 1,
    },
    isLoading: false,

    setHouseData: (houseData: IHouse[]) => set(() => ({ houseData })),
    changePriceRange: (range: { min: number; max: number }) => set(() => ({ priceRange: range })),
    changeSizeRange: (range: { min: number; max: number }) => set(() => ({ sizeRange: range })),
    setScreenshotMode: (screenshotMode: boolean) => set(() => ({ screenshotMode })),
    setCurrentFilter: (currentFilter: string) => set(() => ({ currentFilter })),
    setCurrentRoomVariables: (currentRoomVariables: IRoomVariables) => set(() => ({ roomVariables: currentRoomVariables })),
    setIsLoading: (isLoading: boolean) => set(() => ({ isLoading })),
}));

export default VStore;
